// Import Dependencies
import { Navigate, useLocation, useOutlet } from "react-router";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

// Local Imports
import { useAuthStore } from "@/store/useAuthStore";
import { GHOST_ENTRY_PATH, REDIRECT_URL_KEY } from "@/constants/app";
import { Button } from "@/components/ui";

// ----------------------------------------------------------------------

export default function AuthGuard() {
  const outlet = useOutlet();
  const { isAuthenticated, user, logout } = useAuthStore();

  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`${GHOST_ENTRY_PATH}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  const isRoleRequiringQueue = user?.roleName === "Support Center Supervisor" || user?.roleName === "Support Center Agent";
  const hasNoQueues = !user?.queueIdAndName || user.queueIdAndName.length === 0;

  if (isRoleRequiringQueue && hasNoQueues) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center p-4 bg-gray-50 dark:bg-dark-900 text-center">
        <ExclamationTriangleIcon className="size-16 text-warning-500 mb-4" />
        <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">No queue assigned</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-sm">
          Contact your administrator. You don't have any assigned queue.
        </p>
        <Button color="primary" onClick={() => logout()}>
          Go back to Login
        </Button>
      </div>
    );
  }

  return <>{outlet}</>;
}
